import React from 'react'

export default function SignatureAuditDownload({ enabled = false, audit, onDownload, previous = false }) {
  if (!enabled || !audit?.key) return null
  return <button type="button" className="text-primary-main underline text-left" onClick={() => onDownload({ key: audit.key })}>
    {previous ? 'Download previous PDF with audit' : 'Download signed PDF with audit'}
  </button>
}
